// src/libs/i18n.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Dynamic loader (kept)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const mod = locales(key)
      messages[locale] = mod && mod.default ? mod.default : mod
    }
  })
  return messages
}

const messages = loadLocaleMessages()

// Choice-format plural rules for $tc()
const pluralizationRules = {
  ru(n) {
    const abs = Math.abs(n); const mod10 = abs % 10; const mod100 = abs % 100
    if (mod10 === 1 && mod100 !== 11) return 0 // one
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1 // few
    return 2 // many/other
  },
  uk(n) {
    const abs = Math.abs(n); const mod10 = abs % 10; const mod100 = abs % 100
    if (mod10 === 1 && mod100 !== 11) return 0
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1
    return 2
  },
  es(n) { return n === 1 ? 0 : 1 }, // one / other
  de(n) { return n === 1 ? 0 : 1 },
}

const STORAGE_KEY = 'appLocale'

export const speechLangByLocale = {
  en: 'en-US', ru: 'ru-RU', uk: 'uk-UA', es: 'es-ES', de: 'de-DE',
}

function normalizeToAvailable(code) {
  if (!code) return null
  const lower = code.toLowerCase()
  if (messages[lower]) return lower
  const base = lower.split('-')[0]
  return messages[base] ? base : null
}
function detectLocale() {
  const fromEnv = normalizeToAvailable(process.env.VUE_APP_I18N_LOCALE)
  if (fromEnv) return fromEnv
  const saved = normalizeToAvailable(localStorage.getItem(STORAGE_KEY))
  if (saved) return saved
  const nav = (navigator.languages && navigator.languages[0]) || navigator.language || 'en'
  const fromNav = normalizeToAvailable(nav)
  if (fromNav) return fromNav
  return normalizeToAvailable(process.env.VUE_APP_I18N_FALLBACK_LOCALE) || 'en'
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: normalizeToAvailable(process.env.VUE_APP_I18N_FALLBACK_LOCALE) || 'en',
  messages,
  pluralizationRules,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

// Helper: use $tc with choice-format key
export function tMinWords(i18nInstance, count) {
  return i18nInstance.tc('common.describe_your_need_min_words_choice', count, { count })
}

export function setLocale(locale) {
  if (!messages[locale]) return
  i18n.locale = locale
  localStorage.setItem(STORAGE_KEY, locale)
}

export default i18n
